import React, { type ReactNode } from "react";
import { Paper, type PaperProps } from "@mui/material";
import { adminSurface } from "../../styles/adminUiTokens";

interface AdminSurfaceProps extends Omit<PaperProps, "children"> {
  children: ReactNode;
  noPadding?: boolean;
}

const AdminSurface: React.FC<AdminSurfaceProps> = ({
  children,
  noPadding = true,
  elevation = 0,
  sx,
  ...rest
}) => (
  <Paper
    elevation={elevation}
    sx={{
      ...adminSurface,
      ...(noPadding ? {} : { p: { xs: 2, sm: 2.5 } }),
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Paper>
);

export default AdminSurface;
